import React, { useState } from "react";
import { homeApi } from "@/lib/api/home";
import { VariantType, useSnackbar } from "notistack";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { useTranslation } from "react-i18next";
type IProps = { style_2?: boolean };

const Form = ({ style_2 = false }: IProps) => {
  const { enqueueSnackbar } = useSnackbar();
  const [email, setEmail] = useState("");
  const { executeRecaptcha } = useGoogleReCaptcha();
  const { t } = useTranslation();

  const handleClickVariant = (variant: VariantType, message: string) => () => {
    enqueueSnackbar(message, { variant });
  };

  const validateEmail = (email: string) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const submitEnquiryForm = async (token: string) => {
    if (!token) {
      handleClickVariant("error", t("footer_error_recaptcha"))();
      return;
    }
    try {
      const resp = await homeApi.subscribeNewsletter(email);
      if (resp.status === 200) {
        handleClickVariant("success", t("footer_subscribed_success"))();
        setEmail("");
      } else {
        handleClickVariant("error", t("footer_error_subscribe"))();
        setEmail("");
      }
    } catch {
      handleClickVariant("error", t("footer_error_subscribe"))();
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!validateEmail(email)) {
      handleClickVariant("error", t("footer_error_valid_email"))();
      return;
    }
    if (!executeRecaptcha) return;
    executeRecaptcha("newsletterSubmit").then(submitEnquiryForm);
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="tp-footer-newsletter-wrapper mb-30">
        <div
          className={`tp-footer-newsletter-input ${
            style_2 ? "tp-footer-5-newsletter-input" : ""
          }`}
        >
          <input
            type="email"
            placeholder={t("footer_placeholder_email")}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div
          className={`${
            style_2
              ? "tp-footer-5-newsletter-submit"
              : "tp-footer-newsletter-submit"
          }`}
        >
          <button
            aria-label="Submit"
            disabled={!email || !validateEmail(email)}
            className="tp-btn"
            style={{
              cursor:
                !email || !validateEmail(email) ? "not-allowed" : "pointer",
            }}
          >
            {t("footer_subscribe")}
          </button>
        </div>
      </div>
    </form>
  );
};

export default Form;
